/**
 * This is a copy of the loading icon from packages.
 * For now we don't import it because we have to import all icons and the theme package.
 * If more is needed in the future then it might be beter to import the theme and icons
 * @TODO migrate everything to the sprite.svg and use the Icon.js component
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

const frames = keyframes`
  0% {
    transform: scale(1);
  }
  20% {
    transform: scale(0.5, 1);
  }
  40% {
    transform: scale(1);
  }
`;

const LoadBar = styled.div`
  margin: 3px 0 0;
  height: 6px;
  width: 100%;
  background-color: ${({ color }) => color};
  animation: ${frames} 1s ease-in-out infinite;

  &:nth-child(1) {
    margin-top: 0;
    animation-delay: 0;
  }

  &:nth-child(2) {
    animation-delay: 0.09s;
  }

  &:nth-child(3) {
    animation-delay: 0.18s;
  }
`;

const Loader = styled.div`
  display: block;
  width: ${props => props.width}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: rotate(-3deg);
`;

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoadingIcon = ({ width = 32, color = '#E60000' }) => (
  <Wrapper>
    <Loader role="status" aria-label="laden" width={width}>
      <LoadBar color={color} />
      <LoadBar color={color} />
      <LoadBar color={color} />
    </Loader>
  </Wrapper>
);

LoadingIcon.propTypes = {
  width: PropTypes.number,
  color: PropTypes.string,
};

export default LoadingIcon;
